import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconButton } from '@mui/material';
// Internap dependencies
import { DeleteIconSG } from '../../components';
/**
 * Delete Button Component
 * @param props DeleteButtonSG Props
 * @returns JSX Element
 */
export const DeleteButtonSG = function (props) {
    const { 
    /** Open Delete Confirm Dialog */ handleDeleteClickOpen, 
    /** Disabled status */ disabled, } = props;
    return (_jsx(IconButton, Object.assign({ disabled: disabled, sx: {
            opacity: disabled ? '0.5' : '1',
            color: 'blackDark.main',
        }, onClick: handleDeleteClickOpen }, { children: _jsx(DeleteIconSG, {}) })));
};
